import {
  CloudDownloadOutlined,
  Facebook,
  GroupsOutlined,
  InsertLink,
  KeyboardArrowDown,
  KeyboardArrowUp,
  PhotoAlbumOutlined,
  PhotoLibraryOutlined,
  PhotoSizeSelectLargeOutlined,
  SettingsBackupRestore,
  SortOutlined,
  WhatsApp
} from '@mui/icons-material'
import { IconButton, List, ListItem, ListItemAvatar, ListItemText, styled, Typography } from '@mui/material'
import { isMobile } from 'mobile-device-detect'
import { useState } from 'react'

const CardStorage = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: '0.875rem',
  fontWeight: 500,
  lineHeight: 1,
  textTransform: 'none',
  [theme.breakpoints.up('sm')]: {
    padding: '0 10px',
    fontSize: '0.75rem',
    lineHeight: 1.25
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '1rem'
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '1.5rem'
  }
}))

export default function FeatureList({ plan }: Readonly<{ plan: 'storage' | 'sharing' | 'expert' | 'free' }>) {
  const [openFeatureList, setOpenFeatureList] = useState(false)

  const handleToggle = () => {
    setOpenFeatureList(!openFeatureList)
  }

  const viewList = isMobile ? openFeatureList : true

  return (
    <>
      {isMobile && (
        <IconButton
          disableRipple
          onClick={handleToggle}
          aria-label={!openFeatureList ? 'Expand' : 'Collapse'}
          sx={{
            color: 'primary.main',
            paddingTop: '30px',
            paddingBottom: '30px',
            height: '20px'
          }}
        >
          <CardStorage>View Plan Details</CardStorage>
          {openFeatureList ? <KeyboardArrowDown fontSize="small" /> : <KeyboardArrowUp fontSize="small" />}
        </IconButton>
      )}
      {viewList && (
        <List
          sx={{
            display: 'inline-block',
            marginBottom: isMobile ? 1 : 4,
            width: '100%',
            maxWidth: '300px',
            paddingTop: isMobile ? '0px' : '30px',
            paddingLeft: '20px',
            minHeight: isMobile ? '0px' : '350px'
          }}
          dense
          disablePadding
        >
          <ListItem sx={{ py: 0 }} dense>
            <ListItemAvatar
              sx={{
                minWidth: 34
              }}
            >
              <PhotoLibraryOutlined color="primary" />
            </ListItemAvatar>
            {plan !== 'free' && <ListItemText primary="Unlimited Buckets" />}
            {plan === 'free' && <ListItemText primary="3 Buckets" />}
          </ListItem>
          <ListItem sx={{ py: 0 }} dense>
            <ListItemAvatar
              sx={{
                minWidth: 34,
                paddingTop: '5px'
              }}
            >
              <CloudDownloadOutlined color="primary" />
            </ListItemAvatar>
            {plan !== 'free' && <ListItemText primary="Up to 1 TB of storage" />}
            {plan === 'free' && <ListItemText primary="50 Images per Bucket" />}
          </ListItem>
          <ListItem sx={{ py: 0 }} dense>
            <ListItemAvatar
              sx={{
                minWidth: 34,
                paddingTop: '5px'
              }}
            >
              <SettingsBackupRestore color="primary" />
            </ListItemAvatar>
            <ListItemText primary="Autobackup" />
          </ListItem>
          {plan === 'storage' && (
            <ListItem sx={{ py: 0 }} dense>
              <ListItemAvatar
                sx={{
                  minWidth: 34,
                  paddingTop: '5px'
                }}
              >
                <Facebook color="primary" />
              </ListItemAvatar>
              <ListItemText primary="Facebook Integration" />
            </ListItem>
          )}
          {plan !== 'storage' && (
            <>
              <ListItem sx={{ py: 0 }} dense>
                <ListItemAvatar
                  sx={{
                    minWidth: 34,
                    paddingTop: '5px'
                  }}
                >
                  <WhatsApp color="primary" />
                </ListItemAvatar>
                <ListItemText primary="WhatsApps & Facebook Integration" />
              </ListItem>
              <ListItem sx={{ py: 0 }} dense>
                <ListItemAvatar
                  sx={{
                    minWidth: 34,
                    paddingTop: '5px'
                  }}
                >
                  <PhotoSizeSelectLargeOutlined color="primary" />
                </ListItemAvatar>
                <ListItemText primary="Professional Photo Editor" />
              </ListItem>

              <ListItem sx={{ py: 0 }} dense>
                <ListItemAvatar
                  sx={{
                    minWidth: 34,
                    paddingTop: '5px'
                  }}
                >
                  <GroupsOutlined color="primary" />
                </ListItemAvatar>
                <ListItemText primary="Unlimited Invites" />
              </ListItem>
            </>
          )}
          {plan !== 'free' && (
            <ListItem sx={{ py: 0 }} dense>
              <ListItemAvatar
                sx={{
                  minWidth: 34,
                  paddingTop: '5px'
                }}
              >
                <SortOutlined color="primary" />
              </ListItemAvatar>
              <ListItemText primary="Sort & Organizational Tools" />
            </ListItem>
          )}
          {plan === 'expert' && (
            <>
              <ListItem sx={{ py: 0 }} dense>
                <ListItemAvatar
                  sx={{
                    minWidth: 34
                  }}
                >
                  <PhotoAlbumOutlined color="primary" />
                </ListItemAvatar>
                <ListItemText primary="Photo Hosting" />
              </ListItem>
              <ListItem sx={{ py: 0 }} dense>
                <ListItemAvatar
                  sx={{
                    minWidth: 34,
                    paddingTop: '5px'
                  }}
                >
                  <InsertLink color="primary" />
                </ListItemAvatar>
                <ListItemText primary="Direct Photo Embed Links" />
              </ListItem>
            </>
          )}
        </List>
      )}
    </>
  )
}
